import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import { SoggettoRuolo } from '../models';


class DataTablesResponse {
    data: SoggettoRuolo[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Injectable({
    providedIn: "root"
})
export class SoggettoRuoloService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}SoggettiRuoli/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    getAll() {
        return this.http.get<SoggettoRuolo[]>(`${this.apiUrl}`);
    }
    insert(s: SoggettoRuolo) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: SoggettoRuolo) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:SoggettoRuolo){
        if(s.id)return this.update(s);
        return this.insert(s);
    }

}
